export function logout(){
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('me');
    window.location.href = '/';
}

export async function refreshAccessToken() {
    const refresh = localStorage.getItem('refresh_token');
    if (!refresh) {
      window.location.href = '/account/login';
      throw new Error('Refresh token invalido!');
    }

  }